// removed by extract-text-webpack-plugin
module.exports = {"wrapfeatured":"mxpgkEmuaw88LIu6RwbMK"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/molecules/FeaturedEvents/style.css
// module id = 257
// module chunks = 101